import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IFormDelegate, IFormOptions } from '@modeso/aumico-lib-core-fe';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextService } from 'angular-i18next';
import { ISubtotalFormDialogResult } from '../../../interfaces/subtotal-form-dialog-result.interface';

@UntilDestroy()
@Component({
    selector: 'templates-subtotal-form',
    templateUrl: './subtotal-form.dialog.html',
    styleUrls: ['./subtotal-form.dialog.scss'],
})
export class SubtotalFormDialogComponent {
    public options: IFormOptions;
    public formDelegate: IFormDelegate;

    constructor(
        public dialogRef: MatDialogRef<SubtotalFormDialogComponent, ISubtotalFormDialogResult | undefined>,
        private localizedTexts: I18NextService,
        @Inject(MAT_DIALOG_DATA) public data: INameId[],
    ) {
        this.prepareFields();
    }

    ngOnInit(): void {
        this.prepareFields();
        const that = this;
        this.formDelegate = {
            onSubmit(result: ISubtotalFormDialogResult) {
                that.savePressed(result);
            },
        };
    }

    private prepareFields(): void {
        this.options = {
            properties: [
                {
                    name: this.localizedTexts.t(
                        'aumico_templates_group_account_mapping_add_subtotal_form_group_options',
                    ) as string,
                    type: 'select',
                    multiple: false,
                    options: this.data,
                    optionsLabel: this.localizedTexts.t(
                        'aumico_templates_group_account_mapping_add_subtotal_form_group_options_label',
                    ) as string,
                    property: 'parentGroup',
                    required: true,
                },
                {
                    name: this.localizedTexts.t('aumico_templates_caption') as string,
                    type: 'text',
                    property: 'caption',
                    required: true,
                },
            ],
            submitText: this.localizedTexts.t('aumico_templates_save') as string,
        };
    }

    private savePressed(result: ISubtotalFormDialogResult) {
        const timestamp = Date.now();
        const timestampString = timestamp.toString();

        this.dialogRef.close({
            name: result.caption + '-' + timestampString,
            caption: result.caption,
            parentGroup: result.parentGroup,
        } as ISubtotalFormDialogResult);
    }

    public closeDialog(): void {
        this.dialogRef.close();
    }
}
